import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

export default function (state = getInitialState.list(), action) {
    switch (action.type) {
        case actionTypes.ASSET_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.ASSET_ITEM_SET: {
            const { asset } = action.payload;
            return { ...state, item: asset };
        }
        case actionTypes.ASSET_ITEM_UPDATE: {
            const { asset } = action.payload;
            const { item } = state;
            return { ...state, item: { ...item, ...asset } };
        }
        case actionTypes.ASSET_PATCH_SUCCESS: {
            const { asset } = action.payload;
            return helpers.getListItemReducer(state, asset);
        }
        case actionTypes.ASSETS_CLEAR:
        case actionTypes.GET_SELECTED_ASSET_REQUEST:
        case actionTypes.ASSETS_GET_REQUEST: {
            return getInitialState.list();
        }
        case actionTypes.GET_SELECTED_ASSET_SUCCESS:
        case actionTypes.ASSETS_GET_SUCCESS:
        case actionTypes.ASSETS_SET: {
            const { assets } = action.payload;
            return helpers.getListReducer(state, assets);
        }
        default: {
            return state;
        }
    }
}
